export const DOCUMENT_TYPE_LABELS = {
  POI: 'PROOF OF IDENTITY',
  POA: 'PROOF OF ADDRESS',
  OTHER: 'OTHER DOC',
};

export const DOCUMENT_STATUS_LABELS = {
  NOT_SENT: 'Required',
  SENT: 'Received',
  REJECTED: 'Rejected',
  APPROVED: 'Approved',
  ADDITIONAL_DOCS: 'Additional Documents Required',
  RE_VERIFICATION_NEEDED: 'Re-Verification Needed',
  NOT_AVAILABLE: 'Not Available',
};

export const DOCUMENT_STATUS_DESCRIPTIONS = {
  NOT_SENT: 'We need you to send us documents as proof of your identity. Click below to upload your documents.',
  SENT: 'Your proof of identity documents have been received and are being processed.',
  REJECTED: 'The proof of identity documents you have sent us have been rejected. Please check your email for more details. Click below to upload new documents.',
  APPROVED: 'We do not need you to send us your proof of identity documents, as you have already been verified.',
  ADDITIONAL_DOCS: 'We need additional documents as proof of identity. Please check your email for more details. Click below to upload your documents.',
  RE_VERIFICATION_NEEDED: 'Re-Verification Needed',
  NOT_AVAILABLE: 'We do not require proof of identity from you at this time.',
};

export const ACCOUNT_STATUS_LABELS = {
  'POI__NOT_SENT--POA__NOT_SENT': 'Not Verified',
  'POI__NOT_SENT--POA__SENT': 'In Review',
  'POI__NOT_SENT--POA__REJECTED': 'In Review',
  'POI__NOT_SENT--POA__APPROVED': 'In Review',
  'POI__NOT_SENT--POA__ADDITIONAL_DOCS': 'In Review',
  'POI__NOT_SENT--POA__RE_VERIFICATION_NEEDED': 'Not Verified',
  'POI__NOT_SENT--POA__NOT_AVAILABLE': 'Not Available',
  'POI__SENT--POA__NOT_SENT': 'In Review',
  'POI__SENT--POA__SENT': 'In Review',
  'POI__SENT--POA__REJECTED': 'In Review',
  'POI__SENT--POA__APPROVED': 'In Review',
  'POI__SENT--POA__ADDITIONAL_DOCS': 'In Review',
  'POI__SENT--POA__RE_VERIFICATION_NEEDED': 'In Review',
  'POI__SENT--POA__NOT_AVAILABLE': 'In Review',
  'POI__REJECTED--POA__NOT_SENT': 'In Review',
  'POI__REJECTED--POA__SENT': 'In Review',
  'POI__REJECTED--POA__REJECTED': 'In Review',
  'POI__REJECTED--POA__APPROVED': 'In Review',
  'POI__REJECTED--POA__ADDITIONAL_DOCS': 'In Review',
  'POI__REJECTED--POA__RE_VERIFICATION_NEEDED': 'In Review',
  'POI__REJECTED--POA__NOT_AVAILABLE': 'In Review',
  'POI__APPROVED--POA__NOT_SENT': 'In Review',
  'POI__APPROVED--POA__SENT': 'In Review',
  'POI__APPROVED--POA__REJECTED': 'In Review',
  'POI__APPROVED--POA__APPROVED': 'Verified',
  'POI__APPROVED--POA__ADDITIONAL_DOCS': 'In Review',
  'POI__APPROVED--POA__RE_VERIFICATION_NEEDED': 'Not Verified',
  'POI__APPROVED--POA__NOT_AVAILABLE': 'Not Available',
  'POI__ADDITIONAL_DOCS--POA__NOT_SENT': 'In Review',
  'POI__ADDITIONAL_DOCS--POA__SENT': 'In Review',
  'POI__ADDITIONAL_DOCS--POA__REJECTED': 'In Review',
  'POI__ADDITIONAL_DOCS--POA__APPROVED': 'In Review',
  'POI__ADDITIONAL_DOCS--POA__ADDITIONAL_DOCS': 'In Review',
  'POI__ADDITIONAL_DOCS--POA__RE_VERIFICATION_NEEDED': 'In Review',
  'POI__ADDITIONAL_DOCS--POA__NOT_AVAILABLE': 'Not Available',
  'POI__RE_VERIFICATION_NEEDED--POA__NOT_SENT': 'Not Verified',
  'POI__RE_VERIFICATION_NEEDED--POA__SENT': 'In Review',
  'POI__RE_VERIFICATION_NEEDED--POA__REJECTED': 'In Review',
  'POI__RE_VERIFICATION_NEEDED--POA__APPROVED': 'Not Verified',
  'POI__RE_VERIFICATION_NEEDED--POA__ADDITIONAL_DOCS': 'In Review',
  'POI__RE_VERIFICATION_NEEDED--POA__RE_VERIFICATION_NEEDED': 'Not Verified',
  'POI__RE_VERIFICATION_NEEDED--POA__NOT_AVAILABLE': 'Not Available',
  'POI__NOT_AVAILABLE--POA__NOT_SENT': 'Not Available',
  'POI__NOT_AVAILABLE--POA__SENT': 'Not Available',
  'POI__NOT_AVAILABLE--POA__REJECTED': 'Not Available',
  'POI__NOT_AVAILABLE--POA__APPROVED': 'Not Available',
  'POI__NOT_AVAILABLE--POA__ADDITIONAL_DOCS': 'Not Available',
  'POI__NOT_AVAILABLE--POA__RE_VERIFICATION_NEEDED': 'Not Available',
  'POI__NOT_AVAILABLE--POA__NOT_AVAILABLE': 'Not Available',
};
